import { render } from "./MicrophoneIcon.vue?vue&type=template&id=aa5bc8e6"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__